

const CommentsContainer = () => {
  return (
    <div className="m-5 mx-10 p-2">
      <h1 className='text-2xl font-bold'>Comments :</h1>
    </div>
  )
}

export default CommentsContainer
